export const resolveHasStudents = res => {
    if (res === null || res === undefined) return null;
    if (Array.isArray(res)) return res.length > 0;
    if (typeof res !== 'object') return null;

    const payload = res.payload && typeof res.payload === 'object' ? res.payload : res;

    const list = Array.isArray(res.list) ? res.list : Array.isArray(payload.list) ? payload.list : null;
    if (list) return list.length > 0;

    const count = [res.count, payload.count, res.total, payload.total].find(
        value => typeof value === 'number' || (typeof value === 'string' && value.trim() !== '')
    );
    if (count !== undefined && Number.isFinite(Number(count))) return Number(count) > 0;

    if (res.statusCode !== undefined || res.message !== undefined || res.error !== undefined) return null;

    return false;
};
